"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MindMappingLineStyle = void 0;
/**
 * 思维导图线样式
 */
var MindMappingLineStyle;
(function (MindMappingLineStyle) {
    MindMappingLineStyle[MindMappingLineStyle["NORMAL"] = 0] = "NORMAL";
    MindMappingLineStyle[MindMappingLineStyle["CUBIC_BEZIER"] = 1] = "CUBIC_BEZIER";
})(MindMappingLineStyle = exports.MindMappingLineStyle || (exports.MindMappingLineStyle = {}));
